var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.851 6.28772L1.03852 0.787725C0.934877 0.751649 0.824108 0.740906 0.715468 0.756394C0.606829 0.771882 0.503474 0.813151 0.414046 0.876752C0.324618 0.940353 0.251714 1.02444 0.201428 1.12198C0.151142 1.21952 0.124936 1.32767 0.125 1.43741V16.5624C0.125 16.7447 0.197433 16.9196 0.326364 17.0485C0.455296 17.1775 0.630164 17.2499 0.8125 17.2499C0.994836 17.2499 1.1697 17.1775 1.29864 17.0485C1.42757 16.9196 1.5 16.7447 1.5 16.5624V12.9264L16.851 7.5871C16.9861 7.54034 17.1033 7.45264 17.1862 7.3362C17.2691 7.21976 17.3137 7.08036 17.3137 6.93741C17.3137 6.79446 17.2691 6.65507 17.1862 6.53862C17.1033 6.42218 16.9861 6.33448 16.851 6.28772ZM1.5 11.4706V2.40421L14.5324 6.93741L1.5 11.4706Z",
    fill: "#826258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.f964e3a1d68f473f82f3726a01481cfd.svg";
export { ForwardRef as ReactComponent };